module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cc7da3f731df277b7281d4f3f43420d9.png";